import styled from "styled-components";

import Div from "@components/Div";

const StyledDiv = styled(Div)`

`;

export default StyledDiv;
